import { createSlice } from '@reduxjs/toolkit';

import { formReducer, formState } from './form';
import { processFlowAction, processFlowReducer, processFlowSelector, processFlowState } from './process-flow';

/** Settings BatchTypeLibrary Slice. */
export const settingsBatchTypeLibrarySlice = createSlice({
  name: 'feature_settings_batchTypeLibrary',
  initialState: {
    ...formState,
    ...processFlowState,
  },
  reducers: {
    ...formReducer,
    ...processFlowReducer,
  },
  selectors: {
    ...processFlowSelector,
  },
});

/** Settings BatchTypeLibrary Slice Actions. */
export const settingsBatchTypeLibrarySliceActions = {
  ...settingsBatchTypeLibrarySlice.actions,
  ...processFlowAction(settingsBatchTypeLibrarySlice),
};

/** Settings BatchTypeLibrary Slice Selectors. */
export const settingsBatchTypeLibrarySliceSelectors = settingsBatchTypeLibrarySlice.selectors;
